import { capitialiseFirstLetter } from 'src/app/core/helpers/format-text';
import { isBooleanGroupKey } from 'src/app/project/modules/points/points-group-sizes/match-partial-count';
import { TPointCustomFieldSumResponse } from 'src/app/project/modules/points/points-custom-fields-sum/points-custom-fields-sum.const';
import { TPoint } from 'src/app/project/modules/points/points.model';
import { TColumn } from '../../../columns/column.model';
import { getEmptyGroupName } from '../../../grouping/empty-group-name';
import { TTableItem } from '../../table.model';
import { formatPartialSumValue } from './format-partial-sum-values';

const FALSE_GROUP_VALUE = 'false';

export function buildMatchId(groupBy: Record<string, unknown>): string {
  const sortedEntries = Object.entries(groupBy).sort(([a], [b]) => a.localeCompare(b));
  const segments = sortedEntries.map(([key, val]) => {
    if (isBooleanGroupKey(key) && !val) {
      return capitialiseFirstLetter(FALSE_GROUP_VALUE);
    }

    return val ? capitialiseFirstLetter(String(val)) : getEmptyGroupName();
  });

  return `-${segments.join('-')}`;
}

const partialSumIndexCache = new WeakMap<TPointCustomFieldSumResponse, Map<string, number>>();

function getPartialSumIndex(total: TPointCustomFieldSumResponse): Map<string, number> {
  const cached = partialSumIndexCache.get(total);
  if (cached) {
    return cached;
  }

  const index = new Map<string, number>();

  formatPartialSumValue(total.partialSums ?? []).forEach((partialSum) => {
    if (!partialSum.groupBy) {
      return;
    }

    const matchId = buildMatchId(partialSum.groupBy).toLowerCase();

    if (!index.has(matchId)) {
      index.set(matchId, partialSum.sum ?? 0);
    }
  });

  partialSumIndexCache.set(total, index);
  return index;
}

export const calculateGroupedHeaderSum = (
  item: TTableItem,
  total: TPointCustomFieldSumResponse,
): number => {
  if (!item.groupBy || !total) {
    return 0;
  }

  return getPartialSumIndex(total).get(buildMatchId(item.groupBy).toLowerCase()) ?? 0;
};

export const manuallyCalculateSum = (searchedPoints: TPoint[], column: TColumn): number => {
  let newValue = 0;

  searchedPoints.forEach((point) => {
    if (column.customFieldIds) {
      column.customFieldIds.forEach((customFieldId) => {
        if (point.customFieldsMap?.[customFieldId]?.value) {
          newValue += +point.customFieldsMap[customFieldId].value;
        }
      });
    }
  });

  return newValue;
};
